import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { GlobalRouteNames, SuccessRouteNames } from '../../models/Common';
import EmailConfirmed from '../../components/successParts/EmailConfirmed/EmailConfirmed';
import MembershipConfirmed from '../../components/successParts/MembershipConfirmed/MembershipConfirmed';
import SurveySuccess from '../../components/successParts/SurveySuccess/SurveySuccess';
import SurveySent from '../../components/successParts/SurveySent/SurveySent';
import { AnimatedIcon } from '../../components/commons/AnimatedIcon';
import SuccessIconLight from '../../assets/images/lottieIcons/success/success.light.json';
import SuccessIconDark from '../../assets/images/lottieIcons/success/success.dark.json';

interface SuccessPages {
  component: JSX.Element;
  routePath: SuccessRouteNames;
  isExact?: boolean;
}

export const SuccessPublicPages = () => {
  const { path } = useRouteMatch();

  const successPages: SuccessPages[] = [
    { component: <EmailConfirmed />, routePath: SuccessRouteNames.EmailConfirmed },
    { component: <SurveySent />, routePath: SuccessRouteNames.SurveySent },
    { component: <SurveySuccess />, routePath: SuccessRouteNames.SurveySuccess },
    { component: <MembershipConfirmed />, routePath: SuccessRouteNames.MembershipConfirmed },
  ];

  return (
    <div className="success_page page">
      <div className="success_page__container container">
        <div className="success_page__icon-container">
          <AnimatedIcon
            lightIcon={SuccessIconLight}
            darkIcon={SuccessIconDark}
            className="success_page__icon-container__icon"
          />
        </div>
        <Switch>
          {successPages.map((page) => {
            return (
              <Route exact={!!page.isExact} path={path.concat(page.routePath)} key={page.routePath}>
                {page.component}
              </Route>
            );
          })}
          <Redirect to={GlobalRouteNames.HomePage} />
        </Switch>
      </div>
    </div>
  );
};
